import type { ModuleManifest } from '../types.js'

/**
 * Нийтийн сайт `web.maximus.mn`-ийн CMS.
 *
 * Laravel-ийн `packages/core/website` (+ `news`) багцаас бүрэн портлогдсон —
 * cloud-ыг зогсоох замд үлдсэн СҮҮЛЧИЙН багц байв ([[17-laravel-cutover]] §C3).
 *
 * ! НИЙТИЙН API НЬ ЭНЭ МОДУЛИЙН СЭЛГҮҮРТ ЗАХИРАГДАХГҮЙ. `/api/website/v1/*`
 * ! нь `@Public()` тул модулийг унтраахад ч ажилласаар байна — унтраах нь
 * ! АДМИНЫ дэлгэцийг нуух үйлдэл. Сайтыг бүхэлд нь хаах цорын ганц газар нь
 * ! Сайтын тохиргоон дахь «Нийтэлсэн» сэлгүүр. Эс тэгвэл сервер дээрх
 * ! тохиргооны алдаа санамсаргүйгээр нийтийн сайтыг унтраах эрсдэлтэй.
 *
 * ! Брэнд, ангилал нь 1С-ээс уншигдана ([[coresoft-erp-1c-module]]). Энэ
 * ! модулийн `website_brands` / `website_categories` нь тэдний ХУУЛБАР БИШ,
 * ! зөвхөн вэбэд нийтлэх давхарга: slug, төлөв, эрэмбэ, орчуулга.
 */
export const websiteModule = {
  key: 'website',
  name: 'Вэбсайт',
  description: 'Нийтийн сайтын хуудас, меню, мэдээ, холбоо барих хүсэлт.',
  version: '1.0.0',
  icon: 'GlobeIcon',

  permissions: [
    { resource: 'website.pages', action: 'list', description: 'Сайтын хуудсууд харах' },
    { resource: 'website.pages', action: 'show', description: 'Хуудасны блокууд харах' },
    { resource: 'website.pages', action: 'manage', description: 'Хуудас, блок үүсгэх, засах, устгах' },

    { resource: 'website.menu', action: 'manage', description: 'Сайтын цэс удирдах' },
    { resource: 'website.settings', action: 'manage', description: 'Сайтын тохиргоо, лого, холбоо барих' },

    { resource: 'website.news', action: 'list', description: 'Мэдээ харах' },
    { resource: 'website.news', action: 'manage', description: 'Мэдээ бичих, нийтлэх' },

    { resource: 'website.messages', action: 'list', description: 'Холбоо барих хүсэлт харах' },
    { resource: 'website.messages', action: 'manage', description: 'Хүсэлтийг барьсан гэж тэмдэглэх' },

    { resource: 'website.catalog', action: 'list', description: 'Вэбэд гарах брэнд, ангилал харах' },
    { resource: 'website.catalog', action: 'manage', description: 'Брэнд, ангиллыг вэбэд нийтлэх' },

    /*
     * ! ЗУРАГ БАЙРШУУЛАХ НЬ ТУСДАА ЭРХ. Урьд нь `website.pages:manage`
     * ! шаарддаг байсан бөгөөд «бүх засварлагч тэр эрхтэй тул давхардал»
     * ! гэсэн тайлбартай байв. Тэр үндэслэл ЗӨВХӨН МЭДЭЭ засах дүр гартал
     * ! үнэн байсан: мэдээний админд хуудас засах эрх өгөхгүйгээр нүүр
     * ! зураг оруулах арга байхгүй болно.
     */
    { resource: 'website.media', action: 'upload', description: 'Вэбсайтын зураг байршуулах' },
  ],

  navigation: [
    {
      label: 'Вэбсайт',
      items: [
        {
          label: 'Хуудсууд',
          href: '/website/pages',
          icon: 'FileTextIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'website.pages:list',
        },
        {
          label: 'Сайтын меню',
          href: '/website/menu',
          icon: 'Menu',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'website.menu:manage',
        },
        {
          label: 'Мэдээ мэдээлэл',
          href: '/website/news',
          icon: 'NewspaperIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'website.news:list',
        },
        {
          label: 'Каталог',
          href: '/website/catalog',
          icon: 'TagIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'website.catalog:list',
        },

        /*
         * ! БАРАА НЬ КАТАЛОГИЙН ТАБ БИШ, ТУСДАА ЦЭС. Хуучин Laravel-д ч
         * ! тусдаа маршрут байв (`website.catalog.products.*`) — 798 бараа
         * ! нь шүүлтүүр, хуудаслалт, брэндээр харах горимтой бүтэн дэлгэц
         * ! шаарддаг бөгөөд брэнд, ангиллын хажууд таб болж багтахгүй.
         */
        {
          label: 'Бараа',
          href: '/website/products',
          icon: 'PackageIcon',
          iconClassName: 'text-orange-600 dark:text-orange-400',
          permission: 'website.catalog:list',
        },
        {
          label: 'Холбоо барих хүсэлт',
          href: '/website/messages',
          icon: 'InboxIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'website.messages:list',
        },
        {
          label: 'Сайтын тохиргоо',
          href: '/website/settings',
          icon: 'SettingsIcon',
          iconClassName: 'text-slate-600 dark:text-slate-400',
          permission: 'website.settings:manage',
        },
      ],
    },
  ],

  /*
   * Блокийн засварлагч нь хуудасны ДОТОР амьдардаг тул `sections` нь тусдаа
   * resource биш — `/website/pages/:id` дээр л засагдана.
   */
  resources: [
    {
      name: 'website.pages',
      label: 'Хуудсууд',
      list: '/website/pages',
      show: '/website/pages/:id',
      create: '/website/pages/create',
      edit: '/website/pages/:id',
      canDelete: true,
    },
    {
      name: 'website.news',
      label: 'Мэдээ',
      list: '/website/news',
      show: '/website/news/:id',
      create: '/website/news/create',
      edit: '/website/news/:id',
      canDelete: true,
    },
    { name: 'website.messages', label: 'Холбоо барих хүсэлт', list: '/website/messages' },
    { name: 'website.catalog', label: 'Каталог', list: '/website/catalog' },
    /*
     * ! `apiPath` ЗААВАЛ. Нэрээс гаргавал `website/products` болох ч бодит
     * ! эцсийн цэг нь каталогийн доор (`website/catalog/products`) — барааны
     * ! ДАРАХ ТОХИРГОО тэнд амьдардаг. Замыг бичихгүй бол data provider
     * ! байхгүй зам рүү очно.
     */
    {
      name: 'website.products',
      label: 'Бараа',
      apiPath: 'website/catalog/products',
      list: '/website/products',
    },
  ],
} as const satisfies ModuleManifest
